import React from "react";

const Delivered = () => {
  return <div>Deliver</div>;
};

export default Delivered;
